export class PermissionType {
    id: number;
    code: string;
    name: string;
    state: any;


    constructor(id: number, code: string, name: string) {
        this.id = id;
        this.code = code;
        this.name = name;
    }
}